import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    loginThroughGoogle: {
        method: 'GET',
        url: `${BASE_PATH_API}/public/thirdPartyAuth/google`
    },
    lookupUserLoginsFromEmailAddress: {
        method: 'POST',
        url: `${BASE_PATH_API}/userLogins/lookup`
    },
    loginSubscriberFromThirdParty: {
        method: 'POST',
        url: `${BASE_PATH_API}/auth/thirdParty/login`
    },
    loginWithToken: {
        method: 'POST',
        url: `${BASE_PATH_API}/auth/loginWithToken`
    },
    getLoginSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/auth/login`
    },
    loginAdminUser: {
        method: 'POST',
        url: `${BASE_PATH_API}/auth/admin/login`
    }
};

export function PublicAuthenticationApi() {
    return createActions(actions);
}
